import React, { useCallback, useContext, useState } from 'react';
import styled from 'styled-components';
import BasePhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import ConfigContext from '../../contexts/ConfigContext';
import { body } from '../Typography';
import Label from '../Label';

const Container = styled.div.attrs(() => ({ dir: 'ltr' }))`
  .react-tel-input {
    border: 0;

    > input {
      ${body};
      border-radius: 5px;
      width: 100%;
      border: 1px solid #d9d9d9;
      outline: 0;
      padding: 10px 40px 10px 40px;
      background: ${({ theme }) => theme.colors.surface};
      min-height: 46px;
      ${({ theme, error }) =>
        error && `border-color: ${theme.colors.failure}; background:${theme.colors.failureLight};`}

      &:focus {
        box-shadow: ${({ theme }) => theme.colors.inputShadow};
        border: 1px solid ${({ theme }) => theme.colors.primary};
      }
    }

    .flag-dropdown {
      border: none;
      background: transparent;

      &.open,
      :hover {
        background: transparent;
        > div {
          background: transparent;
        }
      }

      > .selected-flag:focus {
        background: transparent;
        box-shadow: ${({ theme }) => theme.colors.inputShadow};
      }
    }

    .search {
      padding: 0;
      > input {
        margin: 0;
        width: 100%;
        padding: 10px 7px;
        border: none;
        border-bottom: 1px solid ${({ theme }) => theme.colors.gray800};
        border-radius: 0;
      }
    }
  }
`;

const CUSTOM_MASKS = { gb: '(...) .... ....' };

const PhoneInput = ({ title, value, onChange, error, className, ...restProps }) => {
  const { countryCode } = useContext(ConfigContext);
  const [localValue, setLocalValue] = useState(value);

  const handleChange = useCallback(
    (newValue, { dialCode, countryCode }) => {
      if (newValue === dialCode) {
        onChange(null, { countryCode });
        setLocalValue(dialCode);
      } else {
        onChange(newValue);
        setLocalValue(newValue);
      }
    },
    [onChange]
  );

  return (
    <Label title={title} error={error} className={className}>
      <Container error={error}>
        <BasePhoneInput
          value={localValue}
          onChange={handleChange}
          placeholder=""
          enableSearch
          disableSearchIcon
          country={countryCode.toLowerCase()}
          countryCodeEditable={false}
          masks={CUSTOM_MASKS}
          {...restProps}
        />
        {restProps?.children}
      </Container>
    </Label>
  );
};

export default PhoneInput;
